import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import messages from './messages';
import MonitoringCalendarView from 'features/stock/production-monitoring/containers/monitoring-calendar-view/monitoring-calendar-view';

const CalendarPage = () => {
  const {t} = useTranslation();
  return (
    <Fragment>
      <Helmet>
        <title> {t(...messages.title())}</title>
      </Helmet>
      <MonitoringCalendarView />
    </Fragment>
  );
};

export default CalendarPage;
